var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiCommentArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 10.9451L7.54506 15.4001L6.27246 14.1275L12.0001 8.3999L17.7277 14.1275L16.4551 15.4001L12.0001 10.9451Z",
    fill: "#0A0D14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCommentArrow);
export default __webpack_public_path__ + "static/media/ai-comment-arrow.878441afddd08a6b90dc46e3d2aa264b.svg";
export { ForwardRef as ReactComponent };